// import React from 'react';
// import { motion } from 'framer-motion';
// import Footer from '../../../components/Footer';
// import {
//     Utensils,
//     Building,
//     GraduationCap,
//     Stars,
//     Briefcase,
//     Clock,
//     Bookmark,
//     ArrowUpRight,
//     Users,
//     BookOpen,
//     Award,
//     Globe,
//     Rocket,
//     Target,
//     Flag
// } from 'lucide-react';
// import { Link } from 'react-router-dom';
// import Title from '../../../components/TitleComponent';


// const diplomaCourses = [
//     { name: "Diploma in Food Production", path: "diploma-in-food-production" },
//     // /programmes/diploma-courses/best-bakery-and-confectionery-college-in-dehradun-uttarakhand
//     { name: "Diploma in Bakery and Confectionary", path: "best-bakery-and-confectionery-college-in-dehradun-uttarakhand" },
//     { name: "Diploma in Food & Beverage Service & Bar Tending", path: "diploma-in-food-and-beverage" },
//     { name: "Diploma in Front Office", path: "diploma-in-front-office" },
//     { name: "Diploma in Housekeeping", path: "diploma-in-housekeeping" }
// ];

// const degreeCourses = [
//     { name: "Bachelor of Hotel Management (BHM)", path: "bachelor/bhm-colleges-in-dehradun-uttarakhand" },
//     { name: "Bachelor of Science – Hotel Management (B.Sc. – HM)", path: "bsc/hotel-management" },
//     { name: "Master of Hotel Management (MHM)", path: "masters/hotel-management" },
//     { name: "Master of Tourism and Travel Management (MTTM)", path: "masters/tourism-and-travel-management" }
// ];

// const aviationCourses = [
//     { name: "Diploma in Aviation Management (DAM)", path: "best-diploma-in-aviation-management-college-in-dehradun-uttarakhand" },
//     { name: "Bachelor in Aviation Management", path: "bachelor/aviation-management" },
//     { name: "Master in Aviation Management", path: "masters/aviation-management" }
// ];

// const Stats = () => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 my-4 md:my-8 px-4"
//     >
//         {[
//             { icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, number: "1000+", label: "Students Enrolled", color: "bg-blue-50" },
//             { icon: <BookOpen className="w-6 h-6 md:w-8 md:h-8" />, number: "12+", label: "Programs Offered", color: "bg-green-50" },
//             { icon: <Award className="w-6 h-6 md:w-8 md:h-8" />, number: "90%", label: "Placement Rate", color: "bg-purple-50" },
//             { icon: <Globe className="w-6 h-6 md:w-8 md:h-8" />, number: "50+", label: "Industry Partners", color: "bg-orange-50" }
//         ].map((stat, index) => (
//             <motion.div
//                 key={index}
//                 className={`${stat.color} p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300`}
//                 whileHover={{ scale: 1.02 }}
//             >
//                 <div className="text-[#0e4d38]">{stat.icon}</div>
//                 <h3 className="text-xl md:text-2xl font-bold mt-2 text-gray-800">{stat.number}</h3>
//                 <p className="text-gray-600 text-xs md:text-sm">{stat.label}</p>
//             </motion.div>
//         ))}
//     </motion.div>
// );



// const AboutSection = () => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         className="bg-white p-6 rounded-xl shadow-lg"
//     >
//         <div className="flex items-center gap-3 mb-4 border-b pb-4">
//             <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
//                 <BookOpen className="w-6 h-6" />
//             </div>
//             <h4 className="text-xl font-semibold text-[#0e4d38]">About the School of Hotel Management and Tourism</h4>
//         </div>
//         <div className="space-y-4 text-gray-700">
//             <p>Welcome to the esteemed School of Hotel Management and Tourism (SOHMT) at Maya Devi University, a premier institution renowned for its excellence in hotel management education within Dehradun. </p>

//             <p>Our mission at SOHMT is to provide unparalleled education and training for students seeking success in the Hospitality & Tourism sector. With state-of-the-art infrastructure, a comprehensive curriculum, immersive learning opportunities, and a supportive atmosphere, we are dedicated to nurturing the holistic development of our students. Our goal is to empower individuals to thrive in diverse career paths with confidence. </p>

//             <p>We are committed to delivering a multifaceted and integrated learning experience, continuously updating our curriculum to reflect the latest industry trends and innovations. Join us at SOHMT, where your journey to success in the Hospitality & Tourism industry begins.
//             </p>
//         </div>
//     </motion.div>
// );

// const VisionMissionSection = () => (
//     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//         <motion.div
//             initial={{ opacity: 0, x: -20 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true }}
//             className="bg-white p-6 rounded-xl shadow-lg"
//         >
//             <div className="flex items-center gap-3 mb-4 border-b pb-4">
//                 <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
//                     <Target className="w-6 h-6" />
//                 </div>
//                 <h4 className="text-xl font-semibold text-[#0e4d38]">Vision & Mission of the School of Hotel Management & Tourism (SoHM)</h4>
//             </div>
//             <ul className="space-y-3 text-gray-700">
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>“Empowering Future Leaders”

//                     </span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>"To be a premier institution recognized for excellence in hospitality and tourism education, shaping innovative and responsible leaders who contribute to a sustainable and dynamic global industry."</span>
//                 </li>
//             </ul>
//         </motion.div>

//         <motion.div
//             initial={{ opacity: 0, x: 20 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true }}
//             className="bg-white p-6 rounded-xl shadow-lg"
//         >
//             <div className="flex items-center gap-3 mb-4 border-b pb-4">
//                 <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
//                     <Flag className="w-6 h-6" />
//                 </div>
//                 <h4 className="text-xl font-semibold text-[#0e4d38]">Mission</h4>
//             </div>
//             <ul className="space-y-3 text-gray-700">
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>"To be a premier institution recognized for excellence in hospitality and tourism education, shaping innovative and responsible leaders who contribute to a sustainable and dynamic global industry."</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>M2: "To foster a culture of sustainability and ethical practices in the hospitality and tourism industries, preparing graduates to make a positive impact on their communities and the environment."</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>M3: "To cultivate a diverse and inclusive learning environment that encourages creativity, critical thinking, and cultural awareness, enabling students to become adaptive leaders in the evolving landscape of hospitality and tourism."</span>
//                 </li>
//             </ul>
//         </motion.div>
//     </div>
// );


// const WhySection = () => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         className="bg-white p-6 rounded-xl shadow-lg"
//     >
//         <div className="flex items-center gap-3 mb-4 border-b pb-4">
//             <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
//                 <BookOpen className="w-6 h-6" />
//             </div>
//             <h4 className="text-xl font-semibold text-[#0e4d38]">Why Choose Us?</h4>
//         </div>
//         <motion.div
//             initial={{ opacity: 0, x: 20 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true }}
//             className="bg-white p-6 rounded-xl shadow-lg"
//         >
//             <div className="flex items-center gap-3 mb-4 border-b pb-4">
//                 <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
//                     <Flag className="w-6 h-6" />
//                 </div>
//                 <h4 className="text-xl font-semibold text-[#0e4d38]">Academic Excellence</h4>

//             </div>
//             <ul className="space-y-3 text-gray-700">
//                 <h4 className="text-xl font-semibold text-[#0e4d38]">Expert Faculty & Curriculum Design</h4>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Industry-experienced, domain-specific faculty with proven expertise</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Curriculum aligned with national and international hospitality education standards</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Collaborative course design by academic experts and industry professionals</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Choice Based Credit System (CBCS) for comprehensive assessment</span>
//                 </li>
//             </ul>
//             <ul className="space-y-3 text-gray-700 mt-2">
//                 <h4 className="text-xl font-semibold text-[#0e4d38]">Innovative Teaching Methodology</h4>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Advanced Learning Management System (LMS) integration</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Interactive classroom teaching approaches</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Experiential learning through Centers of Excellence</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Live industry projects integrated throughout the program</span>
//                 </li>
//             </ul>
//             <ul className="space-y-3 text-gray-700 mt-2">
//                 <h4 className="text-xl font-semibold text-[#0e4d38]">Personalized Student Development</h4>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>One-on-one progress monitoring and mentoring</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Holistic focus on intellectual, physical, and social growth</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Regular diagnostic assessments for career development</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Continuous core skill development and guidance</span>
//                 </li>
//             </ul>




//         </motion.div>



//         <motion.div
//             initial={{ opacity: 0, x: 20 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true }}
//             className="bg-white p-6 rounded-xl shadow-lg mt-4"
//         >
//             <div className="flex items-center gap-3 mb-4 border-b pb-4">
//                 <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
//                     <Flag className="w-6 h-6" />
//                 </div>
//                 <h4 className="text-xl font-semibold text-[#0e4d38]">Industry Integration</h4>

//             </div>
//             <ul className="space-y-3 text-gray-700">
//                 <h4 className="text-xl font-semibold text-[#0e4d38]">Real-World Experience</h4>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Full-time industrial internship after third year</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Hands-on training in domain-specific technology


//                     </span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Industry-relevant projects throughout the course duration</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Regular interaction with sector professionals</span>
//                 </li>
//             </ul>
//             <ul className="space-y-3 text-gray-700 mt-2">
//                 <h4 className="text-xl font-semibold text-[#0e4d38]">Career Advancement</h4>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Dedicated placement mentoring and career guidance</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Industry-academia gap bridging through updated syllabus</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Start-up and Innovation Lab access for entrepreneurial growth</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Professional development workshops and training</span>
//                 </li>
//             </ul>
//             <ul className="space-y-3 text-gray-700 mt-2">
//                 <h4 className="text-xl font-semibold text-[#0e4d38]">Key Differentiators</h4>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>State-of-the-art facilities for practical training</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Focus on entrepreneurship and innovation</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Comprehensive placement support system</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>Blend of theoretical knowledge and practical skills</span>
//                 </li>
//             </ul>




//         </motion.div>

//     </motion.div>
// );
// const DeansMessage = () => (
//     <motion.div
//         initial={{ opacity: 0, x: 20 }}
//         whileInView={{ opacity: 1, x: 0 }}
//         viewport={{ once: true }}
//         className="bg-white p-6 rounded-xl shadow-lg"
//     >
//         <div className="flex items-center gap-3 mb-4 border-b pb-4">
//             <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
//                 <Flag className="w-6 h-6" />
//             </div>
//             <h4 className="text-xl font-semibold text-[#0e4d38]">Dean’s Message </h4>
//         </div>
//         <div className="space-y-4 text-gray-700">
//             <p>Dear Aspiring Hospitality Professionals,<br />
//                 Welcome to the School of Hotel Management & Tourism at Maya Devi University.

//             </p>

//             <p>As the hospitality industry evolves rapidly, our school stands at the forefront of educational innovation. We offer a unique blend of theoretical knowledge and practical exposure through our industry-integrated curriculum designed by leading experts in the field. </p>

//             <p>Our strength lies in three core pillars: hands-on industry experience, personalized mentoring, and a global perspective. With state-of-the-art facilities and experienced faculty, we transform passionate students into industry-ready professionals who lead rather than follow.
//             </p>
//             <p>The Choice Based Credit System, coupled with our strong industry connections, ensures that our students receive not just education, but a launchpad for their careers. Our placement cell and industry partnerships provide excellent opportunities for internships and professional growth.
//             </p>
//             <p>Join us to transform your passion for hospitality into a rewarding career. At Maya Devi University, excellence isn't just taught – it's lived every day
//             </p>
//         </div>

//         {/* <ul className="space-y-3 text-gray-700">
//             <li className="flex items-start gap-2">
//                 <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                 <span>The Faculty of Engineering offers a range of programs that incorporate cutting-edge techniques, providing students with a comprehensive engineering education. </span>
//             </li>
//             <li className="flex items-start gap-2">
//                 <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                 <span>We prioritize systematic evaluation and feedback to support continuous learning and improvement. </span>
//             </li>
//             <li className="flex items-start gap-2">
//                 <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                 <span>To inspire and motivate students, the faculty creates various platforms where they can cultivate their creativity and innovation. </span>
//             </li>
//             <li className="flex items-start gap-2">
//                 <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                 <span>Additionally, our strategic international partnerships offer students valuable opportunities for global exposure and participation  in collaborative research projects with leading institutions.  </span>
//             </li>
//         </ul> */}
//     </motion.div>
// );


// const CourseCard = ({ course, index }) => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         transition={{ delay: index * 0.1 }}
//         className="group w-full"
//     >
//         <Link to={course.path}>
//             <div className="bg-white p-3 md:p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 h-full flex flex-col justify-between gap-2 md:gap-3">
//                 <div>
//                     <div className="flex justify-between items-start">
//                         <div className="p-2 bg-blue-50 rounded-lg">
//                             <GraduationCap className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
//                         </div>
//                         <motion.div
//                             whileHover={{ scale: 1.1 }}
//                             className="p-1 md:p-2 rounded-full hover:bg-gray-100"
//                         >
//                             <ArrowUpRight className="w-3 h-3 md:w-4 md:h-4 text-gray-400 group-hover:text-[#0e4d38]" />
//                         </motion.div>
//                     </div>
//                     <h3 className="text-sm md:text-lg font-semibold mt-2 md:mt-3 text-gray-800 group-hover:text-[#0e4d38] transition-colors line-clamp-2">
//                         {course.name}
//                     </h3>
//                 </div>
//                 <div className="flex items-center gap-2 md:gap-3 text-xs text-gray-500">
//                     <div className="flex items-center gap-1">
//                         <Clock className="w-3 h-3" />
//                         <span>{course.name.includes('Master') ? '2 Years' : course.name.includes('Diploma') ? '2 Years' : course.name.includes('Bachelor of Science') ? '3 Years' : course.name.includes('Bachelor') ? '4 Years' : '1 Year'}</span>
//                     </div>
//                     <div className="flex items-center gap-1">
//                         <Bookmark className="w-3 h-3" />
//                         <span>{course.name.includes('Master') ? 'PG' : course.name.includes('Bachelor') ? 'UG' : 'Diploma'}</span>
//                     </div>
//                 </div>
//             </div>
//         </Link>
//     </motion.div>
// );

// const Department = ({ title, icon, courses }) => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
//     >
//         <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
//             <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
//                 {icon}
//             </div>
//             <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
//         </div>
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
//             {courses.map((course, index) => (
//                 <CourseCard key={index} course={course} index={index} />
//             ))}
//         </div>
//     </motion.div>
// );

// const FeatureList = ({ title, items, icon }) => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
//     >
//         <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
//             <div className="p-2 md:p-3 bg-[#0e4d38] rounded-xl text-white">
//                 {icon}
//             </div>
//             <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
//         </div>
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
//             {items.map((item, index) => (
//                 <motion.div
//                     key={index}
//                     className="p-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300"
//                     whileHover={{ scale: 1.02 }}
//                 >
//                     <div className="flex items-start gap-2">
//                         <div className="w-2 h-2 mt-1.5 bg-[#23376c] rounded-full flex-shrink-0" />
//                         <span className="text-gray-700 text-xs md:text-sm">{item}</span>
//                     </div>
//                 </motion.div>
//             ))}
//         </div>
//     </motion.div>
// );

// const HeroSection = () => (
//     <div className="relative overflow-hidden bg-[#0e4d38] text-white py-8 md:py-16 px-4 md:px-6 rounded-xl mb-6 md:mb-8 mt-16 md:mt-20">
//         <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="max-w-5xl"
//         >
//             <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 md:mb-4">
//                 School of Hotel Management
//             </h1>
//             <p className="text-sm md:text-lg text-gray-200 mb-4 md:mb-6 max-w-3xl">
//                 Cultivating hospitality excellence through hands-on learning and industry-focused education.
//                 Join us in shaping the future of hospitality management.
//             </p>
//             <Link to="https://admission.maya.edu.in/">
//                 <motion.button
//                     whileHover={{ scale: 1.05 }}
//                     whileTap={{ scale: 0.95 }}
//                     className="bg-white text-[#0e4d38] px-4 md:px-6 py-2 md:py-3 rounded-full text-sm md:text-base font-semibold flex items-center gap-2 group"
//                 >
//                     Apply Now
//                     <Rocket className="w-3 h-3 md:w-4 md:h-4 group-hover:translate-x-1 transition-transform" />
//                 </motion.button>
//             </Link>
//         </motion.div>
//     </div>
// );

// const HotelManagement = () => {
//     return (
//         <div className="min-h-screen bg-gray-50 font-poppins">
//             <Title canonicalPath="/programmes/ug-courses/hotel-management-and-tourism" />
//             <Title title="School of Tourism and Hotel Management at MDU" description="Join the School of Tourism and Hotel Management at MDU, Dehradun. Gain expertise in tourism, hospitality, and hotel management for a successful career." />
//             <div className="max-w-7xl mx-auto pt-16 md:pt-20 pb-8 md:pb-16 px-4 space-y-6 md:space-y-8">
//                 <HeroSection />
//                 <Stats />
//                 <AboutSection />
//                 <VisionMissionSection />
//                 <WhySection />
//                 <DeansMessage />
//                 <div className="space-y-6 md:space-y-8">
//                     {/* <Department
//                         title="Diploma Programs"
//                         icon={<GraduationCap className="w-5 h-5 md:w-6 md:h-6" />}
//                         courses={diplomaCourses}
//                     /> */}
//                     <Department
//                         title="Degree Programs"
//                         icon={<Building className="w-5 h-5 md:w-6 md:h-6" />}
//                         courses={degreeCourses}
//                     />
//                     {/* <Department
//                         title="Aviation Programs"
//                         icon={<Utensils className="w-5 h-5 md:w-6 md:h-6" />}
//                         courses={aviationCourses}
//                     /> */}
//                 </div>

//                 <div className="space-y-6 md:space-y-8">
//                     <FeatureList
//                         title="USPs"
//                         icon={<Stars className="w-6 h-6 text-[#0e4d38]" />}
//                         items={[
//                             "Industry-Experienced Faculty",
//                             "State-of-the-art Training Kitchen",
//                             "Hands-on Training in Hotel Operations",
//                             "International Culinary Programs",
//                             "Industry Partnerships with Leading Hotels",
//                             "Regular Industry Visits",
//                             "Professional Internship Programs",
//                             "Modern Computer Labs",
//                             "Well-equipped Housekeeping Labs",
//                             "Front Office Training Center",
//                             "Food & Beverage Service Labs",
//                             "Guest Lectures by Industry Experts"
//                         ]}
//                     />

//                     <FeatureList
//                         title="Career Options"
//                         icon={<Briefcase className="w-6 h-6 text-[#0e4d38]" />}
//                         items={[
//                             "Hotel General Manager",
//                             "Restaurant Manager",
//                             "Executive Chef",
//                             "Food & Beverage Director",
//                             "Front Office Manager",
//                             "Housekeeping Manager",
//                             "Event Manager",
//                             "Cruise Line Operations",
//                             // "Aviation Hospitality",
//                             "Resort Management",
//                             "Catering Manager",
//                             "Hotel Consultant"
//                         ]}
//                     />
//                 </div>
//             </div>
//             <Footer />
//         </div>
//     );
// };

// export default HotelManagement;





import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../../../components/Footer';
import {
    GraduationCap,
    Stars,
    Clock,
    Bookmark,
    ArrowUpRight,
    Users,
    BookOpen,
    Award,
    Globe,
    Rocket,
    BookType,
    FlaskConical,
    Microscope,
    Stethoscope,
    FileText,
    Download,
    User,
    FileDigit,
    ShieldCheck,
    Users2,
    FileCheck,
    School,
    ArrowRight,
    Beaker,
    Trophy, Atom, Zap, Shield, LucideSearch, Activity, CheckCircle,
} from 'lucide-react';
import { Link } from 'react-router-dom';

import Title from '../../../components/TitleComponent';
import Dean from "../../../assets/schools/hm/Deepa mam.jpg";
import overview from "../../../assets/schools/hm/overview.webp";
import Why from "../../../assets/schools/hm/why.webp";
import {
    TbPlant2,
    TbWorldWww,
    TbSchool,
    TbFlask,
    TbUsers,
    TbBriefcase,
    TbLeaf,
    TbTrophy,
    TbAward,
    TbQuote,

} from "react-icons/tb";
import { Target, Eye } from "lucide-react";
import { useState } from "react";





import IBR from '../../../assets/schools/hm/IBR.jpg';

import temp1 from '../../../assets/schools/hm/placements/temp (1).jpg';
import temp2 from '../../../assets/schools/hm/placements/temp (2).jpg';
import temp3 from '../../../assets/schools/hm/placements/temp (3).png';
import temp4 from '../../../assets/schools/hm/placements/temp (4).png';
import temp5 from '../../../assets/schools/hm/placements/temp (5).png';

import Javed from '../../../assets/schools/hm/students/Javed Ali.jpg';
import Nitin from '../../../assets/schools/hm/students/Nitin Bhatt.jpg';
import Sagar from '../../../assets/schools/hm/students/Sagar Singh.jpg';
import Sahil from '../../../assets/schools/hm/students/sahil.jpg';
import Shagun from '../../../assets/schools/hm/students/Shagun Gupta.jpg';
// import Shweta1 from '../../../assets/schools/hm/students/Shweta.png';


import EducationLogoSlider from '../../../components/EducationLogoSlider';

const HmCourses = {
    Diploma: [
        { name: "Diploma in Food Production (DFP)", path: "best-d-pharma-college-in-dehradun-uttarakhand" },
        { name: "Diploma in Bakery & Confectionery", path: "best-d-pharma-college-in-dehradun-uttarakhand" },
    ],
    undergraduate: [
        { name: "Bachelor of Hotel Management (BHM)", path: "bsc-pcm-colleges-in-dehradun-uttarakhand" },
        { name: "Bachelor of Hotel Management LE(BHM)", path: "bsc-pcm-colleges-in-dehradun-uttarakhand" },
        { name: "Bachelor of Hotel Management & Catering Technology (BHMCT)", path: "bsc-pcm-colleges-in-dehradun-uttarakhand" },
        { name: "Bachelor of Hotel Management & Catering Technology LE (BHMCT)", path: "bsc-pcm-colleges-in-dehradun-uttarakhand" },

    ],
    postgraduate: [
        { name: "Masters of Hotel Management (MHM)", path: "/programmes/pg-courses/science/msc-botany" },
    ],
    doctorate: [
        { name: "Masters of Hotel Management (MHM)", path: "/programmes/phd-courses/pharmacy/DoctorPharmacy" }
    ]
};


const AboutSection = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-8 rounded-xl shadow-lg mb-12"
    >
        {/* Overview section with image - side by side on web, stacked on mobile */}
        <div className="flex flex-col lg:flex-row gap-8 items-center mb-10">
            <div className="w-full lg:w-1/2">
                <div className="flex items-center gap-3 mb-6">
                    <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                        <BookOpen className="w-6 h-6" />
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Overview</h2>
                </div>
                <div className="space-y-4 text-gray-700 text-lg">
                    <p>Welcome to the esteemed School of Hotel Management and Tourism at Maya Devi University, a
                        premier institution renowned for its excellence in hotel management education within
                        Dehradun. <br />
                        The Department of Hotel Management was established in 2012 under the umbrella of the Maya
                        Devi Educational Foundation. Since its inception, the department has been committed to
                        nurturing talent and shaping future leaders in the Hospitality and Tourism industry.<br />
                        At SOHM, our mission is to provide unparalleled education and hands-on training for students
                        aiming to succeed in the vibrant and ever-evolving Hospitality & Tourism sector.<br />
                        Equipped with state-of-the-art infrastructure, a comprehensive and industry-relevant
                        curriculum, immersive learning experiences, and a supportive learning environment, we strive to
                        foster the holistic development of every student.<br />
                        Our goal is to empower individuals with the confidence and competence needed to excel across
                        a wide spectrum of career opportunities in the hospitality domain.<br />
                        We are dedicated to offering a multifaceted and integrated educational experience, consistently
                        updating our curriculum to reflect the latest trends, innovations, and demands of the global
                        hospitality industry.<br />
                        Join us at SOHM—where your journey to a successful career in the Hospitality and Tourism
                        industry begins
                    </p>
                </div>
            </div>
            <div className="w-full lg:w-1/2 relative h-80 md:h-96 rounded-xl overflow-hidden shadow-xl">
                <img
                    src={overview}
                    alt="School of Hotel Management and Tourism"
                    className="w-full h-full object-cover rounded-xl transition-transform duration-700 hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0e4d38]/70 to-transparent flex items-end">
                    <div className="p-6">
                        <h3 className="text-white text-xl font-bold">Cutting-edge Learning Environment</h3>
                        <p className="text-white/80 text-sm">Modern classrooms and advanced labs</p>
                    </div>
                </div>
            </div>
        </div>

        {/* Mission section - full width on web, normal on mobile */}
        <div className="w-full mb-10">
            <div className="flex items-center gap-3 mb-6">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Target className="w-6 h-6" />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Mission</h2>
            </div>
            <div className="text-gray-700 text-lg">
                <p>The mission of the School of Hotel Management includes several key objectives:<br />
                    M1: "To deliver an innovative and comprehensive education in hospitality and tourism,
                    equipping students with practical skills and theoretical knowledge essential for success in a
                    competitive global market."<br />
                    M2: "To foster a culture of sustainability and ethical practices in the hospitality and tourism
                    industries, preparing graduates to make a positive impact on their communities and the
                    environment."<br />
                    M3: "To cultivate a diverse and inclusive learning environment that encourages creativity,
                    critical thinking, and cultural awareness, enabling students to become adaptive leaders in the
                    evolving landscape of hospitality and tourism." <br />

                </p>
            </div>
        </div>

        {/* Vision section - full width on web, normal on mobile */}
        <div className="w-full">
            <div className="flex items-center gap-3 mb-6">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Eye className="w-6 h-6" />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Vision</h2>
            </div>
            <div className="text-gray-700 text-lg">
                <p>“Empowering Future Leaders”
                    "To be a premier institution recognized for excellence in hospitality and tourism education,
                    shaping innovative and responsible leaders who contribute to a sustainable and dynamic global
                    industry."</p>
            </div>
        </div>
    </motion.div>
);


const Stats = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 my-3 md:my-8 px-4"
    >
        {[
            // { icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, number: "1000+", label: "Students Enrolled", color: "bg-blue-50" },
            { icon: <BookOpen className="w-6 h-6 md:w-8 md:h-8" />, number: "9+", label: "Programs Offered", color: "bg-green-50" },
            { icon: <Award className="w-6 h-6 md:w-8 md:h-8" />, number: "48 LPA", label: "Heighest Package", color: "bg-purple-50" },
            { icon: <Globe className="w-6 h-6 md:w-8 md:h-8" />, number: "1000+", label: "Total Number of Students Placed", color: "bg-orange-50" }
        ].map((stat, index) => (
            <motion.div
                key={index}
                className={`${stat.color} p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300`}
                whileHover={{ scale: 1.02 }}
            >
                <div className="text-[#0e4d38]">{stat.icon}</div>
                <h3 className="text-xl md:text-2xl font-bold mt-2 text-gray-800">{stat.number}</h3>
                <p className="text-gray-600 text-xs md:text-sm">{stat.label}</p>
            </motion.div>
        ))}
    </motion.div>
);

const TestimonialCard = ({ student, index }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: index * 0.2 }}
        className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col h-full"
    >
        <div className="bg-gradient-to-r from-[#0e4d38]/10 to-[#23376c]/10 p-4">
            <div className="flex items-center gap-3">
                <div className="w-14 h-14 rounded-full bg-gray-200 overflow-hidden">
                    <img
                        src={student.image}
                        alt={student.name}
                        className="w-full h-full object-cover"
                    />
                </div>
                <div>
                    <h3 className="font-bold text-lg text-gray-800">{student.name}</h3>
                    <div className="flex items-center gap-1 text-sm text-gray-600">
                        <Building className="w-3 h-3" />
                        <span>{student.company}</span>
                    </div>
                </div>
            </div>
        </div>

        <div className="p-6 flex-1 flex flex-col">
            <div className="text-[#0e4d38] mb-3">
                <MessageSquareQuote className="w-6 h-6" />
            </div>
            <p className="text-gray-700 italic flex-1">{student.testimonial}</p>

            <div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-between">
                {student.award && (
                    <div className="flex items-center gap-1 text-sm text-gray-600">
                        <Award className="w-4 h-4 text-[#0e4d38]" />
                        <span>{student.role}</span>
                    </div>
                )}
                {/* <div className="text-sm text-gray-500">Class of {student.graduationYear}</div> */}
            </div>
        </div>
    </motion.div>
);

const StudentTestimonials = () => {
    const testimonials = [
        {
            name: "Shagun Gupta",
            role: "Holiday Inn, Jaipur",
            quote: "SOHM gave me the perfect blend of theoretical knowledge and practical exposure.The faculties were more like mentors, always encouraging us to aim higher. My time here prepared me to work in the luxury hospitality sector with confidence and professionalism.",
            image: Shagun
        },
        {
            name: "Sahil singh",
            role: "Fairmont Jaipur",
            quote: "From live kitchen sessions to internship opportunities, SOHM shaped me into a confident hospitality professional. The curriculum is industry-aligned, and the practical labs were instrumental in building my skillset.",
            image: Sahil
        },
        {
            name: "Sagar Singh",
            role: "ITC, Savoy, Mussoorie",
            quote: "Joining SOHM was a turning point in my life. The infrastructure, placement support, and hands-on training helped me get placed with one of the top hotel chains in the country. I will always be grateful for this journey.",
            image: Sagar
        },
        {
            name: "Javed Ali",
            role: "ITC, Rajputana, Jaipur",
            quote: "The environment at SOHM is nurturing and vibrant. We were encouraged to participate in events, competitions, and internships that gave real-world insights. The support I received helped me become who I am today.",
            image: Javed
        },
        {
            name: "Nitin Bhatt",
            role: "QASAR AL WATAN, Abu dhabi",
            quote: "SOHM is more than just a college—it’s a foundation for aspiring professionals. With excellent faculty and updated curriculum, I felt well-prepared to enter the hospitality industry with confidence.",
            image: Nitin
        }
    ];

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-white p-8 rounded-xl shadow-lg mb-12"
        >
            <div className="flex items-center gap-3 mb-8">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Users className="w-6 h-6" />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Student Testimonials</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {testimonials.map((testimonial, index) => (
                    <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: index * 0.2 }}
                        className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col h-full hover:shadow-lg transition-all duration-300"
                    >
                        <div className="bg-gradient-to-r from-[#0e4d38]/10 to-[#23376c]/10 p-4">
                            <div className="flex items-center gap-3">
                                <div className="w-14 h-14 rounded-full overflow-hidden">
                                    <img
                                        src={testimonial.image}
                                        alt={testimonial.name}
                                        className="w-full h-full object-cover"
                                        loading="lazy"
                                    />
                                </div>
                                <div>
                                    <h3 className="font-bold text-lg text-gray-800">{testimonial.name}</h3>
                                    <p className="text-sm text-gray-600">{testimonial.role}</p>
                                </div>
                            </div>
                        </div>

                        <div className="p-6 flex-1 flex flex-col">
                            <div className="text-[#0e4d38] mb-3">
                                <TbQuote size={24} />
                            </div>
                            <p className="text-gray-700 italic flex-1">{testimonial.quote}</p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </motion.div>
    );
};

const CourseCard = ({ course, index }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: index * 0.1 }}
        className="group w-full"
    >
        <Link to={course.path}>
            <div className="bg-white p-3 md:p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 h-full flex flex-col justify-between gap-2 md:gap-3">
                <div>
                    <div className="flex justify-between items-start">
                        <div className="p-2 bg-blue-50 rounded-lg">
                            {course.name.toLowerCase().includes('pharm d') ? (
                                <GraduationCap className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
                            ) : course.name.toLowerCase().includes('m.pharm') ? (
                                <BookType className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
                            ) : (
                                <FlaskConical className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
                            )}
                        </div>
                        <motion.div
                            whileHover={{ scale: 1.1 }}
                            className="p-1 md:p-2 rounded-full hover:bg-gray-100"
                        >
                            <ArrowUpRight className="w-3 h-3 md:w-4 md:h-4 text-gray-400 group-hover:text-[#0e4d38]" />
                        </motion.div>
                    </div>
                    <h3 className="text-sm md:text-lg font-semibold mt-2 md:mt-3 text-gray-800 group-hover:text-[#0e4d38] transition-colors line-clamp-2">
                        {course.name}
                    </h3>
                </div>
                <div className="flex items-center gap-2 md:gap-3 text-xs text-gray-500">
                    <div className="flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        <span>
                            {course.name.includes('D.Pharm') ? '2 Years' :
                                course.name.includes('B.Pharm - LE') ? '3 Years' :
                                    course.name.includes('B.Pharm') ? '4 Years' :
                                        course.name.includes('M.Pharm') ? '2 Years' :
                                            course.name.includes('Pharm D') ? '6 Years' : 'Duration'}
                        </span>
                    </div>
                    <div className="flex items-center gap-1">
                        <Bookmark className="w-3 h-3" />
                        <span>
                            {course.name.includes('M.Pharm') ? 'PG' :
                                course.name.includes('Pharm D') ? 'Doctor' : 'UG'}
                        </span>
                    </div>
                </div>
            </div>
        </Link>
    </motion.div>
);

const Department = ({ title, icon }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>

        {/* Diploma Programs */}
        <div className="mb-8">
            <h5 className="text-lg font-semibold text-gray-800 mb-4">Diploma Program</h5>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                {HmCourses.Diploma.map((course, index) => (
                    <CourseCard key={index} course={course} index={index} />
                ))}
            </div>
        </div>
        {/* Undergraduate Programs */}
        <div className="mb-8">
            <h5 className="text-lg font-semibold text-gray-800 mb-4">Undergraduate Programs</h5>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                {HmCourses.undergraduate.map((course, index) => (
                    <CourseCard key={index} course={course} index={index} />
                ))}
            </div>
        </div>

        {/* Postgraduate Programs */}
        <div className="mb-8">
            <h5 className="text-lg font-semibold text-gray-800 mb-4">Postgraduate Programs</h5>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                {HmCourses.postgraduate.map((course, index) => (
                    <CourseCard key={index} course={course} index={index} />
                ))}
            </div>
        </div>

        {/* Doctorate Programs */}
        {/* <div>
            <h5 className="text-lg font-semibold text-gray-800 mb-4">Doctor Programs</h5>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                {HmCourses.doctorate.map((course, index) => (
                    <CourseCard key={index} course={course} index={index} />
                ))}
            </div>
        </div> */}
    </motion.div>
);

const FeatureList = ({ title, items, icon }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-xl text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
            {items.map((item, index) => (
                <motion.div
                    key={index}
                    className="p-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300"
                    whileHover={{ scale: 1.02 }}
                >
                    <div className="flex items-start gap-2">
                        <div className="w-2 h-2 mt-1.5 bg-[#23376c] rounded-full flex-shrink-0" />
                        <span className="text-gray-700 text-xs md:text-sm">{item}</span>
                    </div>
                </motion.div>
            ))}
        </div>
    </motion.div>
);

const HeroSection = () => (
    <div className="relative overflow-hidden bg-gradient-to-r from-[#0e4d38] to-[#23376c] text-white py-12 md:py-20 px-6 md:px-10 rounded-xl mb-8 md:mb-12">
        <div className="absolute inset-0 bg-[url('/api/placeholder/1600/800')] bg-cover bg-center opacity-10 mix-blend-overlay" aria-hidden="true"></div>
        <div className="absolute -right-20 -bottom-20 w-64 h-64 bg-white opacity-10 rounded-full blur-3xl" aria-hidden="true"></div>
        <div className="absolute -left-20 -top-20 w-64 h-64 bg-white opacity-10 rounded-full blur-3xl" aria-hidden="true"></div>

        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-6xl mx-auto relative z-10"
        >
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6">
                School of Hotel Management and Tourism
            </h1>
            <h2 className="text-xl md:text-2xl font-semibold mb-6 md:mb-8 text-green-100">
                Shaping Tomorrow's Leaders at Maya Devi University
            </h2>

            <div className="flex flex-wrap gap-4 md:gap-6">
                <Link to="https://admission.maya.edu.in/">
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="bg-white text-[#0e4d38] px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-semibold flex items-center gap-2 group shadow-lg"
                    >
                        Apply Now
                        <Rocket className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
                    </motion.button>
                </Link>
                {/* <Link to="#programs">
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="bg-transparent border-2 border-white text-white px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-semibold flex items-center gap-2 group"
                    >
                        Explore Programs
                        <ArrowRight className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
                    </motion.button>
                </Link> */}
            </div>
        </motion.div>
    </div>
);

// Dean Section Component
const DeanSection = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg overflow-hidden"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
                <GraduationCap className="w-5 h-5 md:w-6 md:h-6" />
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">Principal’s Welcome Message: </h4>
        </div>

        <div className="flex flex-col md:flex-row gap-6 md:gap-10 items-center">
            <div className="w-full md:w-1/3 lg:w-1/4 flex flex-col items-center">
                <motion.div
                    whileHover={{ scale: 1.02 }}
                    className="rounded-xl overflow-hidden max-w-[250px]"
                >
                    <img
                        src={Dean}
                        alt="Dr. Sita Juyal  "
                        className="w-[250px] h-[250px] object-contain bg-white rounded-xl shadow-lg"
                    />
                </motion.div>
                <div className="text-center mt-3">
                    <h5 className="font-bold text-lg text-gray-800">Deepa Chawla</h5>
                    <p className="text-sm text-gray-600">Principal</p>
                </div>
            </div>

            <div className="w-full md:w-2/3 lg:w-3/4 flex flex-col justify-center h-full">
                <p className="text-gray-700 text-sm md:text-base mb-4">
                    Dear Aspiring Hospitality Professionals,<br />
                    Welcome to the School of Hotel Management & Tourism at Maya Devi University.

                </p>
                <p className="text-gray-700 text-sm md:text-base mb-4">
                    As the hospitality industry evolves rapidly, our school stands at the forefront of educational
                    innovation. We offer a unique blend of theoretical knowledge and practical exposure through
                    our industry-integrated curriculum designed by leading experts in the field.
                </p>
                <p className="text-gray-700 text-sm md:text-base">
                    Our strength lies in three core pillars: hands-on industry experience, personalized mentoring, and
                    a global perspective. With state-of-the-art facilities and experienced faculty, we transform
                    passionate students into industry-ready professionals who lead rather than follow.
                </p>
                <p className="text-gray-700 text-sm md:text-base">
                    The Choice Based Credit System, coupled with our strong industry connections, ensures that our
                    students receive not just education, but a launchpad for their careers. Our placement cell and
                    industry partnerships provide excellent opportunities for internships and professional growth.
                </p>
                <p className="text-gray-700 text-sm md:text-base">
                    Join us to transform your passion for hospitality into a rewarding career. At Maya Devi University,
                    excellence isn't just taught – it's lived every day
                </p>
            </div>
        </div>
    </motion.div>
);





const PharmacyDepartment = () => {
    // Data for Global Opportunities
    const globalOpportunities = [
        {
            title: "Licensing Exams",
            items: [
                "FPGEE (Foreign Pharmacy Graduate Equivalency Exam)",
                "GPhC Registration Exam (UK)",
                "NAPLEX (USA)",
                "PEBC (Canada)"
            ]
        },
        {
            title: "Higher Education",
            items: [
                "Postgraduate Programs Abroad",
                "Research Fellowships",
                "Ph.D. Opportunities"
            ]
        },
        {
            title: "Certifications",
            items: [
                "Clinical Pharmacy Certification (FCCP)",
                "Pharmaceutical Sciences Certifications",
                "Regulatory Affairs Certifications"
            ]
        }
    ];

    // Placements Data
    const placements = [
        { name: "Arpit", company: "Cipla Pharmaceuticals", position: "Assistant Manager", ctc: "5.5 LPA", image: temp1 },
        { name: "Asha", company: "East African Overseas", position: "Senior Officer", ctc: "3.3 LPA", image: temp2 },
        { name: "Kuldeep Kumar", company: "Mankind Pharma", position: "Business Executive", ctc: "5 LPA", image: temp3 },
        { name: "Ravi Kumar", company: "NKG Advisory", position: "Officer", ctc: "1.8 LPA", image: temp4 },
        { name: "Suhail Bashir Khan", company: "Govt District Hospital", position: "Pharmacist", ctc: "4.80 LPA", image: temp5 },
        // { name: "Jeewan Chandra Joshi", company: "Zee Lab Ltd", position: "Sr Executive", ctc: "6.90 LPA", image: Shweta },
    ];



    // Patents Data
    const patents = [
        "Dissolution Testing Apparatus To Simulate Colonic BioEnvironment",
        "Portable Electro Spinning Device For Development Of Nanofibres",
        "T-Maze Apparatus For Detection Of Locomotor Activity",
        "Variable Speed Rotating Drum",
        "Oil Filled Coverslip For Microscope",
        "Gas Chromatography Mass Spectrometer Apparatus",
        "Modified Silverson Mixer Emulsifier For Nanoparticle Synthesis"
    ];

    // Clubs Data
    const clubs = [
        {
            name: "Culinary Club:",
            icon: <TbTrophy size={24} />,
            description: "A space for food enthusiasts to explore, cook, and share diverse culinary traditions."
        },
        {
            name: "Sports Club:",
            icon: <TbUsers size={24} />,
            description: "A hub for athletes and fans to engage in physical activities and promote team spirit."
        },
        {
            name: "Hospitality Club:",
            icon: <TbBriefcase size={24} />,
            description: "Dedicated to mastering the art of hosting, service, and event coordination."
        },
        {
            name: "Ikebana Club:",
            icon: <TbLeaf size={24} />,
            description: "Celebrating the art of arrangement through creativity and mindfulness."
        },
        // {
        //     name: "Hobby Clubs",
        //     icon: <TbUsers size={24} />,
        //     description: "Advocates for gender equality and women's professional growth."
        // }
    ];
    const societies = [
        {
            name: "Indian Chemical Society ",
            icon: <TbTrophy size={24} />,
            description: "Promotes physical fitness, teamwork, and healthy competition through various sports activities."
        },
        {
            name: "Institute of Chemistry of Ireland ",
            icon: <TbUsers size={24} />,
            description: "Celebrates creativity through workshops, exhibitions, and cultural festivals."
        },
        {
            name: "American Chemical Society ",
            icon: <TbBriefcase size={24} />,
            description: "Bridges clinical knowledge with management skills for future healthcare leaders."
        },

    ];

    // Testimonials Data
    const testimonials = [
        {
            name: "Shagun Gupta",
            role: "Holiday Inn, Jaipur",
            quote: "SOHM gave me the perfect blend of theoretical knowledge and practical exposure.The faculties were more like mentors, always encouraging us to aim higher. My time here prepared me to work in the luxury hospitality sector with confidence and professionalism.",
            image: "apis/images/placeholder.png"
        },
        {
            name: "Sahil singh",
            role: "Fairmont Jaipur",
            quote: "From live kitchen sessions to internship opportunities, SOHM shaped me into a confident hospitality professional. The curriculum is industry-aligned, and the practical labs were instrumental in building my skillset.",
            image: "apis/images/placeholder.png"
        },
        {
            name: "SAGAR SINGH",
            role: "ITC, Savoy, Mussoorie",
            quote: "Joining SOHM was a turning point in my life. The infrastructure, placement support, and hands-on training helped me get placed with one of the top hotel chains in the country. I will always be grateful for this journey.",
            image: "apis/images/placeholder.png"
        },
        {
            name: "Javed Ali",
            role: "ITC, Rajputana, Jaipur",
            quote: "The environment at SOHM is nurturing and vibrant. We were encouraged to participate in events, competitions, and internships that gave real-world insights. The support I received helped me become who I am today.",
            image: "apis/images/placeholder.png"
        },
        {
            name: "Nitin Bhatt",
            role: "QASAR AL WATAN, Abu dhabi",
            quote: "SOHM is more than just a college—it’s a foundation for aspiring professionals. With excellent faculty and updated curriculum, I felt well-prepared to enter the hospitality industry with confidence.",
            image: "/api/placeholder/300/300"
        }
    ];

    // State for active testimonial
    const [activeTestimonial, setActiveTestimonial] = useState(0);
    const [showCertificate, setShowCertificate] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const InfiniteSlider = ({ placements }) => {
        return (
            <div className="relative">
                {/* Mobile View - Grid Layout */}
                <div className="md:hidden grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {placements.map((student, index) => (
                        <div
                            key={`mobile-${index}`}
                            className="w-full h-full flex justify-center items-center"
                        >
                            <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group">
                                <div className="relative overflow-hidden h-72 w-full">
                                    <img
                                        src={student.image}
                                        alt={`${student.name || 'Graduate'} - ${student.company || 'Placement'}`}
                                        className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105"
                                        loading="lazy"
                                    />
                                    <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-emerald-900/80 to-transparent p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                                        <p className="text-white text-sm font-medium">{student.company || 'Placement'}</p>
                                        {student.name && (
                                            <p className="text-white text-xs">{student.name}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Desktop View - Infinite Slider */}
                <div className="hidden md:block overflow-hidden w-full">
                    <div className="flex animate-infinite-scroll">
                        {/* First set */}
                        {placements.map((student, index) => (
                            <div
                                key={`first-${index}`}
                                className="flex-shrink-0 w-[300px] mx-4"
                            >
                                <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group">
                                    <div className="relative overflow-hidden h-72 w-full">
                                        <img
                                            src={student.image}
                                            alt={`${student.name || 'Graduate'} - ${student.company || 'Placement'}`}
                                            className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105"
                                            loading="lazy"
                                        />
                                        {/* <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-emerald-900/80 to-transparent p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                                            <p className="text-white text-sm font-medium">{student.company || 'Placement'}</p>
                                            {student.name && (
                                                <p className="text-white text-xs">{student.name}</p>
                                            )}
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        ))}
                        {/* Second and third sets remain the same */}
                        {/* ... existing second and third sets code ... */}
                    </div>
                </div>
            </div>
        );
    };


    const WhyUsSection = () => {
        const features = [
            // {
            //     icon: <Zap className="w-7 h-7" />,
            //     title: "Strong Academic Foundation:",
            //     description: "We deliver high-quality education through wellstructured programs, qualified faculty, and a modern curriculum aligned with industry standards. "
            // },
            {
                icon: <Shield className="w-7 h-7" />,
                title: "Expert Faculty & Curriculum Design: ",
                description: "• Industry-experienced, domain-specific faculty with proven expertise • Curriculum aligned with national and international hospitality education standards • Collaborative course design by academic experts and industry professionals • Choice Based Credit System(CBCS) for comprehensive assessment"
            },
            {
                icon: <Globe className="w-7 h-7" />,
                title: "Innovative Teaching Methodology: ",
                description: "• Advanced Learning Management System (LMS) integration • Interactive classroom teaching approaches • Experiential learning through Centers of Excellence • Live industry projects integrated throughout the program"
            },
            {
                icon: <LucideSearch className="w-7 h-7" />,
                title: "Personalized Student Development: ",
                description: "• One-on-one progress monitoring and mentoring • Holistic focus on intellectual, physical, and social growth • Regular diagnostic assessments for career development • Continuous core skill development and guidance"
            },
            {
                icon: <Users className="w-7 h-7" />,
                title: "Real-World Experience: ",
                description: "• Full-time industrial internship after third year • Hands-on training in domain-specific technology • Industry-relevant projects throughout the course duration • Regular interaction with sector professionals "
            },
            {
                icon: <Activity className="w-7 h-7" />,
                title: "Career Advancement: ",
                description: "• Dedicated placement mentoring and career guidance • Industry-academia gap bridging through updated syllabus • Start-up and Innovation Lab access for entrepreneurial growth • Professional development workshops and training"
            },
            {
                icon: <Activity className="w-7 h-7" />,
                title: "Key Differentiators: ",
                description: "• State-of-the-art facilities for practical training • Focus on entrepreneurship and innovation • Comprehensive placement support system • Blend of theoretical knowledge and practical skills "
            },
        ];

        return (
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="bg-white p-8 rounded-xl shadow-lg mb-12"
            >
                <div className="flex flex-col md:flex-row gap-8">
                    <div className="w-full md:w-1/3">
                        <div className="sticky top-24">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                                    <CheckCircle className="w-6 h-6" />
                                </div>
                                <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Why Join Us?</h2>
                            </div>
                            {/* <p className="text-gray-700 mb-6">The School of Life and Applied Sciences offers students a unique opportunity to explore one of the most dynamic and essential fields of science. With a blend of innovative teaching methods and cutting-edge research, our department fosters an environment where curiosity and creativity thrive. Students benefit from projector based classrooms, personalized mentorship, and access to modern lab facilities, ensuring they receive the hands-on experience crucial for mastering complex concepts. Our school is committed to providing diverse learning opportunities, from undergraduate research projects to internships with industry leaders. Moreover, students are encouraged to participate in science clubs, workshops, and seminars, further enhancing their academic experience.  </p> */}
                            <div className="relative h-60 md:h-80 rounded-lg overflow-hidden">
                                <img
                                    src={Why}
                                    alt="Students collaborating"
                                    className="w-full h-full object-cover"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#0e4d38] to-transparent p-4">
                                    <p className="text-white font-semibold">Joining Maya Devi University means becoming part of a progressive academic community dedicated to shaping future leaders, professionals, and innovators. </p>
                                </div>
                            </div>
                            <div className="mt-6">
                                <Link to="https://admission.maya.edu.in/">
                                    <motion.button
                                        whileHover={{ scale: 1.02 }}
                                        whileTap={{ scale: 0.98 }}
                                        className="w-full bg-[#0e4d38] text-white px-6 py-3 rounded-lg text-lg font-semibold flex items-center justify-center gap-2"
                                    >
                                        Apply Now
                                        <ArrowRight className="w-5 h-5" />
                                    </motion.button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="w-full md:w-2/3">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {features.map((feature, index) => (
                                <motion.div
                                    key={index}
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: index * 0.1 }}
                                    className="bg-gray-50 p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300"
                                >
                                    <div className="text-[#0e4d38] mb-4">
                                        <div className="p-3 bg-[#0e4d38]/10 rounded-lg inline-block">
                                            {feature.icon}
                                        </div>
                                    </div>
                                    {/* <h3 className="text-xl font-bold mb-3 text-gray-800">{feature.title}</h3> */}
                                    <p className="text-gray-600">{feature.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>
            </motion.div>
        );
    };

    // Function to move to next testimonial
    const nextTestimonial = () => {
        setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
    };

    // Function to move to previous testimonial
    const prevTestimonial = () => {
        setActiveTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    };

    const viewCertificate = (index) => {
        setSelectedIndex(index);
        setShowCertificate(true);
    };

    const closeCertificate = () => {
        setShowCertificate(false);
    };
    return (
        <div className="font-sans">

            {/* 4. Global Opportunities Section */}
            {/* <section className="py-16 bg-gradient-to-r from-emerald-800 to-emerald-600 text-white">
                <div className="container mx-auto px-4">
                    <div className="bg-white/10 p-10 rounded-2xl backdrop-blur-md border border-white/20 hover:bg-white/20 transition-all duration-300 shadow-md">
                        <h2 className="text-3xl font-bold text-white mb-6">Global Opportunities</h2>
                        <ul className="space-y-6 text-white text-lg leading-relaxed">
                            <li className="flex items-start">
                                <span className="mt-2 mr-3 w-2 h-2 bg-emerald-400 rounded-full"></span>
                                <span>
                                    Postgraduate students are mentored for higher studies and research in top-ranking global institutions.
                                </span>
                            </li>
                            <li className="flex items-start">
                                <span className="mt-2 mr-3 w-2 h-2 bg-emerald-400 rounded-full"></span>
                                <span>
                                    The curriculum aligns with international academic standards, preparing students for exams like GRE, TOEFL, and IELTS for global education pathways.
                                </span>
                            </li>
                            <li className="flex items-start">
                                <span className="mt-2 mr-3 w-2 h-2 bg-emerald-400 rounded-full"></span>
                                <span>
                                    Chemistry graduates can pursue global careers as Research Chemists, Analytical Chemists, Medicinal Chemists, Food Chemists, Computational Chemists, Polymer Chemists, QC Chemists, Nuclear Chemists, and more in sectors like pharma, healthcare, agriculture, and industry.
                                </span>
                            </li>
                            <li className="flex items-start">
                                <span className="mt-2 mr-3 w-2 h-2 bg-emerald-400 rounded-full"></span>
                                <span>
                                    Environmental Science, Botany, Zoology, Microbiology, and Biotechnology graduates find roles in global research organizations, government agencies, and private sector industries.
                                </span>
                            </li>
                            <li className="flex items-start">
                                <span className="mt-2 mr-3 w-2 h-2 bg-emerald-400 rounded-full"></span>
                                <span>
                                    Zoologists can contribute to global conservation initiatives with organizations like WWF, UNEP, and CITES. International research opportunities also exist via ZSI, WWI, DRDO, UCOST, CSIR, ICAR, and other global collaborations.
                                </span>
                            </li>
                        </ul>
                    </div>

                </div>
            </section> */}

            {/* 5.	Program Names:  */}
            <div className="space-y-6 md:space-y-8">
                <Department
                    title="Programs"
                    icon={<Microscope className="w-5 h-5 md:w-6 md:h-6" />}
                />
            </div>

            {/* Dean Section */}
            <DeanSection />

            {/* 7.Students' Achievements / Placements:  */}
            <section className="py-20 bg-gradient-to-b from-gray-50 to-gray-100">
                <div className="container mx-auto px-4">
                    <div className="mb-14 text-center">
                        <h2 className="text-4xl font-bold mb-5 text-emerald-800 relative inline-block">
                            Student Placements
                            {/* <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-emerald-500 rounded-full"></span> */}
                        </h2>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            Our graduates are making an impact in prestigious organizations worldwide
                        </p>
                    </div>

                    {/* Infinite Slider */}
                    <div className="overflow-hidden">
                        <InfiniteSlider placements={placements} />
                    </div>
                </div>
            </section>

            {/* <PlacementPartners /> */}
            <EducationLogoSlider />

            <WhyUsSection />


            {/*10. Awards & Patents Section - Modernized with green theme */}
            <section className="py-16 bg-white">
                <div className="container mx-auto px-4">
                    {/* Heading */}
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-emerald-800 mb-4 flex items-center justify-center">
                            <Trophy className="mr-3" /> Awards &  Recognitions
                        </h2>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            Our department's achievement
                        </p>
                    </div>

                    {/* Patents and Recognition Row */}
                    <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
                        {/* Department Patents Section */}
                        {/* <div className="bg-emerald-50 p-8 rounded-xl shadow-sm">
                            <h3 className="text-2xl font-semibold mb-6 text-emerald-700">
                                India Book of Records
                            </h3>
                            <ul className="space-y-4">
                                {patents.map((patent, index) => (
                                    <li key={index} className="flex items-start">
                                        <span className="bg-emerald-600 text-white rounded-full w-7 h-7 flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                                            {index + 1}
                                        </span>
                                        <span className="text-gray-800">
                                            {patent}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div> */}

                        {/* Department Recognition Section */}
                        <div className="bg-emerald-50 p-8 rounded-xl shadow-sm text-center">
                            <div className="bg-emerald-600 text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                                <Trophy size={28} />
                            </div>

                            <img
                                src={IBR}
                                alt="Department Recognition"
                                className="mx-auto mb-6 rounded-lg shadow-md max-h-64 object-cover"
                            />
                            <h3 className="text-2xl font-semibold text-emerald-800 mb-4">
                                India Book of Records
                            </h3>
                            <p className="text-gray-600">
                                <strong>India Book of Records :</strong>  Prepared 6,185 cookies consisting of a plethora of
                                delectable varieties, including Ragi Black Currant, Jowar Caramel, Singhada Kulfi and
                                Barnyard Coconut in 3 hours and 30 minutes
                            </p>
                        </div>
                    </div>
                </div>
            </section>



            {/* 11. Clubs Section - Modernized with green theme */}
            <section className="py-16 bg-gray-50">
                <div className="container mx-auto px-4">
                    {/* Section Heading */}
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-emerald-800 mb-4">Student Clubs</h2>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            Engage beyond academics with our vibrant student organizations
                        </p>
                    </div>

                    {/* Club Overview Cards */}
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
                        {clubs.map((club, index) => (
                            <div key={index} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                                <div className="bg-gradient-to-r from-emerald-600 to-emerald-500 text-white p-6 flex items-center">
                                    <div className="text-3xl mr-4">{club.icon}</div>
                                    <h3 className="text-xl font-bold">{club.name}</h3>
                                </div>
                                <div className="p-6">
                                    <p className="text-gray-600">{club.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Detailed Descriptions */}
                    {/* <div className="space-y-12">
                        <div>
                            <h3 className="text-2xl font-bold text-emerald-700 mb-2">Sports Club</h3>
                            <p className="text-gray-700 leading-relaxed">
                                The Sports Club at School of Pharmacy is dedicated to promoting physical fitness, teamwork, and a healthy competitive spirit among students. Despite the rigorous academic demands of pharmacy education, we believe that sports and recreational activities play a vital role in maintaining mental and physical well-being.
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                Our club organizes regular intra- and inter-college tournaments in various sports such as cricket, football, badminton, volleyball, table tennis, and athletics. We also encourage participation in university-level competitions and sports meets. Through these activities, students not only stay active but also develop leadership, discipline, and camaraderie.
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                The Sports Club is open to all students, and we welcome both beginners and experienced athletes. Join us to balance your academic life with energy, passion, and fun on the field!
                            </p>
                        </div>

                        <div>
                            <h3 className="text-2xl font-bold text-emerald-700 mb-2">Art and Culture Club</h3>
                            <p className="text-gray-700 leading-relaxed">
                                The Art and Culture Club is a vibrant and inclusive platform that celebrates creativity, diversity, and self-expression. It aims to bring together individuals who are passionate about various forms of art, music, dance, literature, drama, and cultural traditions.


                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                The club serves as a space where members can explore their artistic talents, share ideas, and engage in meaningful cultural activities. It organizes workshops, exhibitions, performances, and cultural festivals that highlight both modern and traditional art forms.
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                Through participation in the club, members not only enhance their creative skills but also develop confidence, teamwork, and a deeper appreciation for the rich cultural heritage of different communities. The Art and Culture Club plays a vital role in enriching the overall experience of students and promoting a lively, expressive, and culturally aware environment.
                            </p>
                        </div>

                        <div>
                            <h3 className="text-2xl font-bold text-emerald-700 mb-2">Health Care Management Club</h3>
                            <p className="text-gray-700 leading-relaxed">
                                The Health Care Management Club is a professional and educational platform that brings together students interested in the administrative, managerial, and leadership aspects of the healthcare industry. The club aims to bridge the gap between clinical knowledge and management skills, preparing future leaders in health systems and services.


                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                Through guest lectures, workshops, seminars, and industry interactions, the club exposes members to real-world healthcare challenges, policy-making, hospital administration, public health strategies, and health economics. It also fosters networking opportunities with healthcare professionals and organizations.
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                The club encourages innovation, critical thinking, and problem-solving to address modern health care issues. Whether you're aiming for a career in hospital management, public health, pharmaceutical administration, or health policy, this club offers valuable insights and experiences to support your journey.
                            </p>
                        </div>

                        <div>
                            <h3 className="text-2xl font-bold text-emerald-700 mb-2">Clean and Green Club</h3>
                            <p className="text-gray-700 leading-relaxed">
                                The Clean and Green Club is dedicated to promoting environmental awareness and sustainability within the campus and the community. The club encourages students to take active roles in protecting nature through initiatives that support cleanliness, green practices, and eco-friendly living.
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                Our activities include tree plantation drives, waste management campaigns, cleanliness drives, recycling initiatives, awareness programs, and participation in national and global environmental observances like Earth Day and World Environment Day.
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                By fostering a sense of responsibility toward the environment, the Clean and Green Club aims to inspire long-term habits that contribute to a cleaner, healthier, and more sustainable planet. Join us in making a difference—one green step at a time!
                            </p>
                        </div>

                        <div>
                            <h3 className="text-2xl font-bold text-emerald-700 mb-2">Women Empowerment Club</h3>
                            <p className="text-gray-700 leading-relaxed">
                                The Women Empowerment Club is committed to promoting gender equality, empowering women, and creating a safe, supportive, and inclusive environment for all. The club serves as a platform to raise awareness about women's rights, genderbased issues, and the importance of equal opportunities in education, careers, and society.
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                We organize seminars, workshops, self-defense training, inspirational talks, skillbuilding sessions, and campaigns that encourage confidence, leadership, and independence among women. The club also works to engage all genders in conversations around equality, respect, and empowerment.
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                Through education, dialogue, and action, the Women Empowerment Club strives to inspire positive change and support the personal and professional growth of women in every walk of life.


                            </p>
                        </div>
                    </div> */}
                </div>
            </section>


            {/*12.  StudentTestimonials */}
            <StudentTestimonials testimonials={testimonials} />

            {/* Call to Action */}
            {/* <section className="py-16 bg-gradient-to-br from-emerald-600 to-emerald-800 text-white">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="text-4xl font-bold mb-6">Begin Your Pharmaceutical Journey</h2>
                    <p className="text-xl mb-8 max-w-2xl mx-auto">
                        Join our prestigious School of Pharmacy and become part of the next generation of pharmaceutical innovators.
                    </p>
                    <div className="flex flex-col sm:flex-row justify-center gap-4">
                        <button className="bg-white text-emerald-800 px-8 py-4 rounded-full font-semibold hover:bg-emerald-50 transition-colors">
                            <Link to="https://admission.maya.edu.in/"> Apply Now </Link>
                        </button>
                        
                    </div>
                </div>
            </section> */}
        </div>
    );
};


// PDF Document Card Component
const DocumentCard = ({ document }) => (
    <motion.div
        whileHover={{ scale: 1.02 }}
        className="bg-white shadow-md rounded-lg overflow-hidden border border-gray-100 hover:shadow-lg transition-all duration-300"
    >
        <div className="p-4">
            <div className="flex justify-between items-center mb-3">
                <div className="p-2 bg-blue-50 rounded-lg">
                    {document.icon}
                </div>
                <a href={document.path} download>
                    <motion.div
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.95 }}
                        className="p-2 bg-gray-50 hover:bg-gray-100 rounded-full"
                    >
                        <Download className="w-4 h-4 text-gray-600" />
                    </motion.div>
                </a>
            </div>
            <h3 className="font-semibold text-gray-800 mb-1 text-sm md:text-base">{document.name}</h3>
            <p className="text-gray-600 text-xs md:text-sm mb-3">{document.description}</p>
            <a
                href={document.path}
                download
                className="inline-flex items-center gap-1 text-xs md:text-sm font-medium text-[#0e4d38] hover:text-[#0a3b2a] transition-colors"
            >
                Download PDF
                <ArrowUpRight className="w-3 h-3" />
            </a>
        </div>
    </motion.div>
);

// PDF Resources Section
const ResourcesSection = ({ category }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
                {category.icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{category.title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {category.documents.map((doc, index) => (
                <DocumentCard key={index} document={doc} />
            ))}
        </div>
    </motion.div>
);

const HotelManagement = () => {
    return (
        <div className="min-h-screen bg-gray-50 font-poppins mt-[70px]">
            <Title canonicalPath="/programmes/ug-courses/hotel-management-and-tourism" />
            <Title title="School of Hotel Management and Tourism at Maya Devi University, Dehradun" description=" Join the School of Hotel Management and Tourism at Maya Devi University, Dehradun. Pursue a rewarding career in Hotel Management and Tourism with expert knowledge and practical skills in Hotel Management and Tourism." />
            <div className="max-w-7xl mx-auto pt-16 md:pt-20 pb-8 md:pb-16 px-4 space-y-6 md:space-y-8">
                <HeroSection />
                <AboutSection />
                <Stats />
                <PharmacyDepartment />

                {/* <StudentAchievements /> */}


                {/* PDF Resources Sections */}
                {/* <div className="space-y-6 md:space-y-8">
                    {pdfResources.map((category, index) => (
                        <ResourcesSection key={index} category={category} />
                    ))}
                </div> */}

                {/* <div className="space-y-6 md:space-y-8">
                    <FeatureList
                        title="USPs"
                        icon={<Stars className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "PCI Approved Programs",
                            "Experienced Faculty with Industry Background",
                            "State-of-the-art Laboratories",
                            "Industry-Integrated Curriculum",
                            "Hands-on Training",
                            "Research Opportunities",
                            "Regular Industrial Visits",
                            "Modern Teaching Methods",
                            "Well-equipped Library",
                            "Industry Collaboration",
                            "Mentorship Program",
                            "Career Development Support"
                        ]}
                    />

                    <FeatureList
                        title="Career Options"
                        icon={<Stethoscope className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "Clinical Pharmacist",
                            "Hospital Pharmacist",
                            "Research Scientist",
                            "Drug Safety Associate",
                            "Quality Control Manager",
                            "Regulatory Affairs Officer",
                            "Production Manager",
                            "Medical Writer",
                            "Pharmaceutical Sales",
                            "Drug Inspector",
                            "Academic Researcher",
                            "Healthcare Consultant"
                        ]}
                    />
                </div> */}
            </div>
            <Footer />
        </div>
    );
};

export default HotelManagement;